"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GENERAL = void 0;
var GENERAL = {
  ROW__EDIT_WAREHOUSE: 'supplierWarehouses-tr-editWarehouse',
  BUTTON__ADD_NEW: 'supplierWarehouses-button-addNewWarehouse'
};
exports.GENERAL = GENERAL;